module.exports = __webpack_public_path__ + "img/22.54c60837.png";